import BackToCatalogButton from './components/BackToCatalogButton';
import useBackToCatalogTrigger from './hooks/useBackToCatalogTrigger';

const BackToCatalogTrigger = () => {
  const { catalogName, isVisible, goToCatalog } = useBackToCatalogTrigger();

  if (!isVisible) {
    return null;
  }

  return <BackToCatalogButton catalogName={catalogName} onClick={goToCatalog} />;
};

export default BackToCatalogTrigger;
